import React, { FC } from 'react';
import { IIconProps } from 'app/components/svgs/Icon';

/**
 * 'copy' icon from IcoMoon SVG icon set:
 * https://raw.githubusercontent.com/Keyamoon/IcoMoon-Free/master/SVG/045-copy.svg
 */
const CopyDocument: FC<IIconProps> = ({ size = '100%', height = size, width = size, color = '#000', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" {...props}>
    <path
      fill={color}
      d="M10 4v-4h-7l-3 3v9h6v4h10v-12h-6zM3 1.414v1.586h-1.586l1.586-1.586zM1 11v-7h3v-3h5v3l-3
        3v4h-5zM9 5.414v1.586h-1.586l1.586-1.586zM15 15h-8v-7h3v-3h5v10z"
    />
  </svg>
);

export default CopyDocument;
